import React from 'react'
// import PropTypes from 'prop-types'
import QuickLinks from 'components/shared/QuickLinks'
import { Row, Col } from 'antd'

export default function SoftwareQuickLinks({ softwares }) {
  if (!softwares) return null
  let title = ''
  const linkList = []
  title = 'Related Softwares'
  softwares.forEach((software) => {
    const { slug, name } = software.attributes
    linkList.push({
      href: '/software/[slug]',
      as: `/software/${slug}`,
      linkText: ` ${name} Review`,
    })
  })

  return (
    <Row style={{ marginBottom: '16px' }}>
      <Col span={24}>
        <QuickLinks title={title} linkList={linkList} />
      </Col>
    </Row>
  )
}

// SoftwareQuickLinks.propTypes = {
//   softwares: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string,
//       slug: PropTypes.string,
//     })
//   ).isRequired,
// }
